import { render, staticRenderFns } from "./admin-order-actions.vue?vue&type=template&id=19a13d34"
import script from "./admin-order-actions.vue?vue&type=script&lang=js"
export * from "./admin-order-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports